import Carousel from "../Carousel";
import SectionHdr from "../SectionHeader";

export default function EditorsPickSection({ books = [], selectedBooks = [], itemLimit = 8, onView, cart, addCart }) {
    const manualBooks = selectedBooks.slice(0, itemLimit);
    let EDITORS_PICK = manualBooks.length
        ? manualBooks
        : books.filter(b => b.badge === "Bestseller" || b.badge === "Editor's Pick" || b.new).slice(0, itemLimit);
    if (EDITORS_PICK.length === 0) EDITORS_PICK = books.slice(0, itemLimit);

    if (EDITORS_PICK.length === 0) return null;

    return (
        <section className="section" style={{
            background: "#FDF5F5",
            paddingTop: "10px",
            paddingBottom: "10px",
            borderTop: "3px solid #C0392B"
        }}>
            <Carousel
                books={EDITORS_PICK}
                onView={onView}
                cart={cart}
                addCart={addCart}
                renderHeader={(dots) => <SectionHdr pill="EDITOR'S PICK" rightContent={dots} />}
            />
        </section>
    );
}
